import { CameraOutlineIc } from '@dsch/dd-icons';

import { useGetAd } from '../../../../../queries/hooks/useGetAd';

import { Text } from '../../../../../../ToolkitV2/Text/Text';
import { LineClamp } from '../../../../../../Toolkit/LineClamp/LineClamp';

import {
  StyledAdCard,
  AdCardImage,
  FallbackImageContainer,
  ImageSkeleton,
  CARD_HEIGHT_PX,
  IMAGE_WIDTH_PX,
} from './AdCard.styled';

import { ORIENTATION } from '../../../../../../ToolkitV2/CardV2/Card.typed';

import { theme } from '../../../../../../../helpers/Theme';
import { Spacer } from '../../../../../../../helpers/genericStyles';
import { CURRENCIES } from '../../../../../../../types';
import { ComponentProps } from 'react';

type Props = {
  adId: string;
  title: string;
  price: number;
  backgroundColor?: ComponentProps<typeof StyledAdCard>['backgroundColor'];
};

const AdCard = (props: Props) => {
  const { adId, title, price, backgroundColor } = props;

  const { data, isPending } = useGetAd(parseInt(adId));

  const imageSrc = data?.photos?.[0].small2Webp;

  const formattedPrice = new Intl.NumberFormat('en-IE', {
    style: 'currency',
    currency: CURRENCIES.EUR,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(price);

  return (
    <StyledAdCard
      header={
        <div>
          <Text color="GREY_DARK" weight="regular" size="M16">
            <LineClamp lines={2}>{title}</LineClamp>
          </Text>
          <Spacer marginBottom="S4" />
          <Text color="GREY_DARKER" weight="bold" size="B18">
            {formattedPrice}
          </Text>
        </div>
      }
      image={
        <>
          {isPending && (
            <ImageSkeleton
              w={IMAGE_WIDTH_PX}
              h={CARD_HEIGHT_PX}
              wMedium={180}
            />
          )}
          {!isPending && imageSrc && <AdCardImage src={imageSrc} alt={title} />}
          {!isPending && !imageSrc && (
            <FallbackImageContainer>
              <CameraOutlineIc
                height="24"
                width="24"
                color={theme.colors.GREY}
              />
            </FallbackImageContainer>
          )}
        </>
      }
      paddingSmall="S12"
      orientationSmall={ORIENTATION.HORIZONTAL}
      backgroundColor={backgroundColor}
      gapSmall="S4"
    />
  );
};

export { AdCard };
